import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class WebHookService {
    constructor(
        private cookieService: CookieService,
        private http: HttpClient
    ) {}

    getWebHookList() {
      const token = this.cookieService.get('accessToken');
      return this.http.post('/api/webhook/get', `access_token=${token}`, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
    }

    add(webHook) {
        const token = this.cookieService.get('accessToken');
        const p = {
            "event_types": [webHook.eventType],
            "url" : webHook.url,
            "name" : webHook?.name,
        }
        const queryParams = [
            `access_token=${token}`,
            `p=${encodeURIComponent(JSON.stringify(p))}`
        ];
        return this.http.post('/api/webhook/create', _.join(queryParams, "&"), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        });
    }

    edit(id, webHook) {
      const token = this.cookieService.get('accessToken');
      const p = {
          "id"  : id,
          "event_types": [webHook.eventType],
          "url"  : webHook.url,
          "name" : webHook?.name,
      }
      const queryParams = [
          `access_token=${token}`,
          `p=${encodeURIComponent(JSON.stringify(p))}`
      ];
      return this.http.post('/api/webhook/update', _.join(queryParams, "&"), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
    }

    delete(id) {
        const token = this.cookieService.get('accessToken');
        const p = {
          "id"  : id
        }
        const queryParams = [
            `access_token=${token}`,
            `p=${encodeURIComponent(JSON.stringify(p))}`
        ];
        return this.http.post('/api/webhook/delete', _.join(queryParams, "&"), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        });
    }

    getFailedTransactions(id){
      const token = this.cookieService.get('accessToken');
      const queryParams = [
        `access_token=${token}`,
        `p=${encodeURIComponent(JSON.stringify({"webHookId": id}))}`
      ];

      return this.http.post('/api/webhook/failed/get/all', _.join(queryParams, "&"), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
    }

    sendTestTransaction(id){
      const token = this.cookieService.get('accessToken');
      const queryParams = [
        `access_token=${token}`,
        `p=${encodeURIComponent(JSON.stringify({"webHookId": id}))}`
      ];

      return this.http.post('/api/webhook/test/send', _.join(queryParams, "&"), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
    }

    resend(errorId){
      const token = this.cookieService.get('accessToken');
      const queryParams = [
        `access_token=${token}`,
        `p=${encodeURIComponent(JSON.stringify({"webHookErrorId": errorId}))}`
      ];

      return this.http.post('/api/webhook/failed/transaction/resend', _.join(queryParams, "&"), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
    }
}
